// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

import App from './App'
import router from './router'
import i18n from './lang/lang'

import VueTruncate from 'vue-truncate-filter'
import FBSignInButton from 'vue-facebook-signin-button'
import VueCarousel from 'vue-carousel'

import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'

import mainMixin from '@/mixins/mainMixin'
import errorMixin from '@/mixins/errorMixin'
import apiMixin from '@/mixins/apiMixin'

import '@/assets/css/vue-directive-tooltip-css.css'

import './filters'

import FlagIcon from 'vue-flag-icon'

import { store } from './store/store'
import PremiumLock from '@/components/elements/PremiumLock'
import PremiumPlanPopup from '@/components/elements/PremiumPlanPopup'

import VueParticles from 'vue-particles'

import { SimpleSVG } from 'vue-simple-svg'
import MainLayout from '@/components/layouts/Main'
import PartnerLayout from '@/components/layouts/Partner'
import ModalHelp from '@/components/elements/ModalHelp2'
import Vuetify from 'vuetify'
import VueSweetalert2 from 'vue-sweetalert2'

import config from '@/config'

import th from 'vee-validate/dist/locale/th'
// import la from './lang/validate/la'

import 'vuetify/dist/vuetify.min.css'
import { Validator } from 'vee-validate'

import VueAnalytics from 'vue-analytics'

import LoadScript from 'vue-plugin-load-script'
import VueCountdown from '@chenfengyuan/vue-countdown'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: config.sentry_dsn,
    debug: process.env.NODE_ENV === 'development',
    environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
    enableInExpoDevelopment: process.env.NODE_ENV === 'development',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'enterprise.zwiz.ai', 'enterprise.zwiz.app', /^\//]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5
  })
}

Vue.prototype.$aston = window.aston
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(LoadScript)

Vue.use(VueAnalytics, {
  id: 'UA-52751393-10',
  router
})

const SweetalertoOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)

Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color
  }
})
Vue.use(VueParticles)

Vue.use(Tooltip)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Validator.localize({ th: th })
// Validator.localize({ la: la })
Vue.use(VeeValidate, { locale: 'th', events: 'blur' })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)

Vue.use(FlagIcon)

Vue.component('main-layout', MainLayout)
Vue.component('partner-layout', PartnerLayout)
Vue.component('v-modal-help', ModalHelp)
Vue.component('v-premium-lock', PremiumLock)
Vue.component('v-premium-plan-popup', PremiumPlanPopup)

Vue.component('vue-simple-svg', SimpleSVG)

Vue.config.productionTip = false

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', (value) => {
  var pattern = new RegExp(
    /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})
Validator.extend('excludednew', {
  getMessage: (field) => field + Vue.prototype.$t('are duplicate please change to another one'),
  validate: (value, [...otherValue]) => {
    var obj = value.replace(/,/g, '').replace(/[|]/g, '//#or//')
    return !otherValue.includes(obj)
  }
})
Validator.extend('isPhone', (value) => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)
Vue.mixin(apiMixin)

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js